import {useState} from 'react';
import {Box} from '@mui/material';

import DashboardHeader from './DashboardHeader';
import {
  dashboardContainerStyle,
  expandedGridStyle,
  normalGridStyle,
  expandedCardStyle,
  dashboardRootContainerStyle,
} from './styles';

import MonthlyRevenueCard from './cards/MonthlyRevenue/MonthlyRevenueCard';
import OutstandingPaymentsCard from './cards/OutstandingPayments/OutstandingPaymentsCard';
import PreferredPaymentMethodsCard from './cards/PerferredPaymentMethods/PreferredPaymentMethodsCard';
import TopInsuranceCompaniesCard from './cards/TopInsuranceCompanies/TopInsuranceCompaniesCard';
import OutstandingInsuranceAmountsCard from './cards/OutStandingInsuranceAmounts/OutstandingInsuranceAmountsCard';
import InsuranceClaimsManagementCard from './cards/InsuranceClaimManagement/InsuranceClaimsManagementCard';
import ExpandedMonthlyRevenue from './cards/ExpandedMonthlyRevenue/ExpandedMonthlyRevenue';
import {useDashboardData} from '../hooks';
import FetchError from '~/components/FetchError';
import DashboardOverviewSkeleton from './DashboardOverviewSkeleton';

const DashboardOverview = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const {data, isLoading} = useDashboardData();

  if (isLoading) {
    return <DashboardOverviewSkeleton />;
  }
  if (!data || !data.data) {
    return <FetchError />;
  }
  const dashboardData = data.data;

  return (
    <Box sx={dashboardRootContainerStyle}>
      <Box sx={dashboardContainerStyle}>
        <DashboardHeader />
        <Box sx={isExpanded ? expandedGridStyle : normalGridStyle}>
          <Box
            sx={
              isExpanded
                ? expandedCardStyle
                : {gridArea: {xs: 'card1', md: 'card1'}}
            }
          >
            {isExpanded ? (
              <ExpandedMonthlyRevenue onClose={() => setIsExpanded(false)} />
            ) : (
              <MonthlyRevenueCard
                onExpand={() => setIsExpanded(true)}
                data={dashboardData}
              />
            )}
          </Box>
          <Box
            sx={
              isExpanded
                ? {gridArea: {xs: 'card3', md: 'card3'}}
                : {gridArea: {xs: 'card2', md: 'card2'}}
            }
          >
            <OutstandingPaymentsCard data={dashboardData} />
          </Box>
          <Box
            sx={
              isExpanded
                ? {gridArea: {xs: 'card1', md: 'card1'}}
                : {gridArea: {xs: 'card3', md: 'card3'}}
            }
          >
            <PreferredPaymentMethodsCard data={dashboardData} />
          </Box>
          <Box
            sx={
              isExpanded
                ? {gridArea: {xs: 'card4', md: 'card4'}}
                : {gridArea: {xs: 'card4', md: 'card4'}, mt: '-30px'}
            }
          >
            <TopInsuranceCompaniesCard data={dashboardData} />
          </Box>
          <Box
            sx={
              isExpanded
                ? {gridArea: {xs: 'card5', md: 'card5'}}
                : {gridArea: {xs: 'card5', md: 'card5'}, mt: '-30px'}
            }
          >
            <OutstandingInsuranceAmountsCard data={dashboardData} />
          </Box>
          <Box
            sx={
              isExpanded
                ? {gridArea: {xs: 'card2', md: 'card2'}}
                : {gridArea: {xs: 'card6', md: 'card6'}, mt: '-30px'}
            }
          >
            <InsuranceClaimsManagementCard data={dashboardData} />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default DashboardOverview;
